import { render } from "./EmailTemplateForm.vue?vue&type=template&id=55f55942&scoped=true"
import script from "./EmailTemplateForm.vue?vue&type=script&lang=js"
export * from "./EmailTemplateForm.vue?vue&type=script&lang=js"

import "./EmailTemplateForm.vue?vue&type=style&index=0&id=55f55942&scoped=true&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f55942"]])

export default __exports__